<input
  #input
  (keydown)="onKeyDown($event)"
  (blur)="focusOut()"
  [(ngModel)]="value"
/>
